export default __webpack_public_path__ + "static/media/Cure It.1c363085.png";